import { Tag, Tooltip } from "antd";
import { FaLock } from "react-icons/fa";

/** The lock badge of a targeted note. It shows the number of readers, and the hover lists their names. */
export const ReadersBadge = ({ readers }: { readers: string[] }) => (
    <Tooltip
        rootClassName="notes-readers-tooltip"
        title={
            <>
                <div className="notes-readers-title">This note is only visible to:</div>
                {readers.map((reader, i) => (
                    <div key={`${reader}-${i}`}>{reader}</div>
                ))}
            </>
        }
    >
        <Tag icon={<FaLock className="notes-readers-lock" />}>{readers.length}</Tag>
    </Tooltip>
);
